import { render, staticRenderFns } from "./PhaseList.vue?vue&type=template&id=19267270&scoped=true&"
import script from "./PhaseList.vue?vue&type=script&lang=ts&"
export * from "./PhaseList.vue?vue&type=script&lang=ts&"
import style0 from "./PhaseList.vue?vue&type=style&index=0&id=19267270&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19267270",
  null
  
)

export default component.exports